/* eslint-disable no-proto */

/*
 * Shim Object.getPrototypeOf() for IE9 and other crappy browsers in order for
 * Babel 6 inheritance and super() calls to work.
 *
 * https://phabricator.babeljs.io/T3041
 */

(function() {
  if (!(Object.setPrototypeOf || {}.__proto__)) {
    const nativeGetPrototypeOf = Object.getPrototypeOf;

    Object.getPrototypeOf = function(object) {
      if (object.__proto__) {
        return object.__proto__;
      } else {
        return nativeGetPrototypeOf.call(Object, object);
      }
    };
  }
})();
